import {
    Button, DataSource, DataSourceMode, Event, Layout, Panel, PanelProps, SelectionMode,
    SlideoutDecorator
} from "@mcleod/components";
import { ExtraPay } from "./ExtraPay";
import { StringUtil } from "@mcleod/core";

export class ExtraPaySlideout extends Panel {
    private orderId: string;
    private movementId: string;
    private endDate: Date;
    private movementDataSource: DataSource;
    private equipmentGroupDataSource: DataSource;
    private rearrangeLayoutPath: string;
    private extraPayLayout: ExtraPay;
    private saveButton: Button = new Button({ id: "extraPaySaveButton", caption: "Save", backgroundColor: "primary", minWidth: 128, borderWidth: 0, rowBreak: false, });

    constructor(movementDatasource: DataSource, equipmentGroupDataSource?: DataSource, props?: Partial<PanelProps>) {
        super({
            maxWidth: 1200, width: 1200, height: window.innerHeight,
            backgroundColor: "defaultBackground", top: 30, padding: 0,
            borderRadius: 4, borderWidth: 1, borderShadow: true, borderColor: "strokeSecondary"
        });
        this.movementDataSource = movementDatasource;
        this.equipmentGroupDataSource = equipmentGroupDataSource;
        this.orderId = movementDatasource?.activeRow?.get("movement_order.order_id") ?? movementDatasource?.activeRow?.get("orders.id");
        this.movementId = movementDatasource?.activeRow?.get("id");
        this.endDate = movementDatasource?.activeRow?.get("stop_dest.sched_arrive_late");
        this.rearrangeLayoutPath = "lme/dispatch/asset/ExtraPay";
    }


    public showSlideout(doAfterClose: (canceled: boolean) => void) {
        if (this.movementDataSource?.activeRow?.get("id")) {
            this.extraPayLayout = Layout.getLayout(this.rearrangeLayoutPath, { fillHeight: true, width: 1200 }) as ExtraPay;
            this.extraPayLayout.mainDataSource = this.movementDataSource;
            this.extraPayLayout.addLayoutLoadListener(event => {
                this.showExtraPay(doAfterClose);
            })
        }
    }

    private showExtraPay(doAfterClose) {
        new SlideoutDecorator({
            layout: this.extraPayLayout,
            title: `Settlement Details - Order ${this.orderId}`,
            fillHeight: true,
            layoutLoadListeners: (event: Event) => {
                const layout = event.target as ExtraPay;
                const tableExtraPay = layout.tableExtraPay;
                tableExtraPay.dataSource.mode = DataSourceMode.UPDATE;
                tableExtraPay.selectionMode = SelectionMode.SINGLE;
                tableExtraPay.fillHeight = true;
                layout.sourceExtraPay.search({"movement_id":this.movementId});
                layout.endDate = this.endDate;
                this.configureDriverDropdown();
            },
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                this.extraPayLayout.doAfterClose = doAfterClose;
                await this.extraPayLayout.sourceMovement.search({"id":this.movementId});
                this.saveButton.addClickListener(event => {
                    this.saveButton.busy = true;
                    this.extraPayLayout.onSave().finally(() => {
                        this.saveButton.busy = false;
                    });
                });
            },
            addlComponents: this.saveButton,
            overlayProps: { width: 1200, height: "60%", closeOnClickOff: false, greyedBackground: true }
        });
    }

    private configureDriverDropdown() {
        const driverIds: string[] = [];
        const driverOneId = this.equipmentGroupDataSource?.data?.[0]?.get("driver_id");
        if((!StringUtil.isEmptyString(driverOneId)))
            driverIds.push(driverOneId);
        const driverTwoId = this.equipmentGroupDataSource?.data?.[1]?.get("driver_id");
        if((!StringUtil.isEmptyString(driverTwoId)))
            driverIds.push(driverTwoId);
        this.extraPayLayout.setDriverIds(driverIds);
    }

}

